module.exports = __webpack_public_path__ + "img/千金子霜.bd99451e.jpg";